// src/constants/lessonSlots.js
//
// Etichetele de slot ale lectiilor practice, in ordinea din calendar. Grila
// ultra (ULTRA_TIME_MARKS) si popup-ul de editare pornesc de la aceeasi lista.

export const LESSON_SLOT_LABELS = [
   "07:00",
   "08:30",
   "10:00",
   "11:30",
   "13:30",
   "15:00",
   "16:30",
   "18:00",
   "19:30",
];

/** Forma {eticheta, oraStart} ceruta de selectoarele de ora din popup-uri. */
export const LESSON_SLOT_OPTIONS = LESSON_SLOT_LABELS.map((value) => ({
   eticheta: value,
   oraStart: value,
}));
